import { useContext } from 'react';
import { useQuery } from 'react-query';
import { BotContext } from '../../components/context';
import { STATE_ANSWER_INTERVAL, qnaStateTypes } from '../constants';
import { getStateAndAnswer } from '../services';

function useQnaState(globalProps) {
    const { setChatStateMode, setLastLVA, selectedRoom, isHistoryReady, config } = useContext(BotContext)
    // const answer = {
    //     text: 'from useqna',
    //     message: '',
    //     buttons: [
    //         { title: "هوای شهری (مانند تهران) رو بگو بهم", payload: "/tthr_weather" }],
    //     images: [],
    //     links: [],
    //     status: true,
    //     question_date: '2023-01-28T07:52:50.603785+03:30',
    // }
    const checkAnswer = (params) => {
        switch (params?.state) {
            case qnaStateTypes.BTC:
                // setIsBotMode(true)
                setChatStateMode(qnaStateTypes.BTC)

                break;
            case qnaStateTypes.LVC:
                // setIsBotMode(false)
                setChatStateMode(qnaStateTypes.LVC)
                if (params?.answers) {
                    setLastLVA(params.answers)
                    globalProps?.triggerNextStep({
                        value: { chat_agent: "OPT" },
                        trigger: "lvA",
                    });
                }
                break;
            case qnaStateTypes.WAT:
                // setIsBotMode(false);
                setChatStateMode(qnaStateTypes.WAT)
                break;

            default:
                setChatStateMode(qnaStateTypes.BTC)
                break;
        }
    }


    const { refetch: getQnaState, data: qnaState } = useQuery('getState', async () => {
        const { data } = await getStateAndAnswer({ room_id: selectedRoom?.name });
        return data
    },
        {
            enabled: !!selectedRoom && isHistoryReady,
            refetchInterval: config.sai,
            onSuccess(data) {
                checkAnswer(data?.data);
            }
        })


    return { getQnaState, qnaState };
}

export { useQnaState };
